import { lazy, Suspense } from 'react';

const Markdown = lazy(() =>
  import('./Markdown.js').then((m) => ({
    default: m.Markdown,
  })),
);

export function LazyMarkdown(props: React.ComponentProps<typeof Markdown>) {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Markdown {...props} />
    </Suspense>
  );
}
